import { AudioSystem } from './systems/core/audio.js';
import { DirToFlipSystem } from './systems/game/dir-to-flip.js';
import { PerfCollectionSystem } from './systems/core/perf.js';
import { MaxHpSystem } from './systems/game/max-hp.js';
import { PhaseSwitchSystem } from './systems/game/phase-switch.js';
import { HpRenderSystem } from './systems/game/hp-render.js';
import { MagicSystem, PhaseToColorSystem } from './systems/game/magic.js';
import { InitializationSystem } from './systems/core/init.js';
import { TargetPosSystem } from './systems/core/target-pos.js';
import { CasterAiSystem } from './systems/game/caster-ai.js';
import { ReceivedDamageSystem } from './systems/game/received-damage.js';
import { DeathSystem } from './systems/game/death.js';
import { CollisionCleanupSystem } from './systems/physics/collision-cleanup.js';
import { OnCollisionSystem } from './systems/physics/collision-dispatching.js';
import { LifetimeSystem } from './systems/core/lifetime.js';
import { InputCursorTranslationSystem } from './systems/core/input-cursor-translation.js';
import { MatterSystem } from './systems/physics/matter.js';
import { MoveSystem } from './systems/core/move.js';
import { WasdControllerSystem } from './systems/game/wasd-controller.js';
import { SceneObjectSystem, RootInitSystem } from './systems/core/scene-object.js';
import { RenderSystem } from './systems/core/render.js';
import { InputSystem } from './systems/core/input.js';


export const setup_systems = (world) => {
  world.addSystemClass(InputCursorTranslationSystem);
  world.addSystemClass(InputSystem);


  world.addSystemClass(LifetimeSystem);
  world.addSystemClass(SceneObjectSystem);
  world.addSystemClass(RootInitSystem);

  world.addSystemClass(PhaseSwitchSystem);

  world.addSystemClass(WasdControllerSystem);
  world.addSystemClass(TargetPosSystem);
  world.addSystemClass(MoveSystem);
  world.addSystemClass(MatterSystem);
  world.addSystemClass(OnCollisionSystem);

  world.addSystemClass(ReceivedDamageSystem);
  world.addSystemClass(DeathSystem);

  world.addSystemClass(RenderSystem);

  world.addSystemClass(CollisionCleanupSystem);
  world.addSystemClass(CasterAiSystem);
  world.addSystemClass(InitializationSystem);
  world.addSystemClass(MagicSystem);
  world.addSystemClass(PhaseToColorSystem);
  world.addSystemClass(MaxHpSystem);
  world.addSystemClass(HpRenderSystem);
  world.addSystemClass(PerfCollectionSystem);
  world.addSystemClass(DirToFlipSystem);
  world.addSystemClass(AudioSystem);
};
